import { render, staticRenderFns } from "./SelectFilePreviewButton.vue?vue&type=template&id=3dabcfa2&scoped=true&"
import script from "./SelectFilePreviewButton.vue?vue&type=script&lang=js&"
export * from "./SelectFilePreviewButton.vue?vue&type=script&lang=js&"
import style0 from "./SelectFilePreviewButton.vue?vue&type=style&index=0&id=3dabcfa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dabcfa2",
  null
  
)

export default component.exports